import axios from 'axios';
import store from './../store';
import { getRefreshToken, getAccessToken } from 'src/auth';
import jwt from 'jsonwebtoken';

const apiAuth = axios.create();

apiAuth.interceptors.request.use(
  (config) => {
    if (store.state.loggedIn && getAccessToken() !== null && jwt.decode(getRefreshToken()).exp > Date.now() / 1000) {
      console.log('(interceptor req) yes, logged in');
      const accessToken = getAccessToken();
      console.log('(interceptor req) add bearer token');
      config.headers.Authorization = `Bearer ${accessToken}`;
    } else {
      console.log('(interceptor req) not logged in');
      store.dispatch('logout').then(() => {
        window.location = '/login';
      });
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

apiAuth.interceptors.response.use(
  (response) => {
    console.log('(interceptor) received apiAuth response');
    return response;
  },
  (error) => {
    console.log(error);
    const originalRequest = error.config;
    console.log('(interceptor resp) error response in apiAuth call (expired token?)');
    if ((error.response.status === 401 || error.response.status === 403) && originalRequest._retry !== true) {
      console.log('(interceptor resp) refreshing access token, then retrying apiAuth request');
      originalRequest._retry = true;
      return store
        .dispatch('refreshToken')
        .then(() => {
          console.log('(interceptor resp) refreshed access_token');
          return apiAuth.request(originalRequest);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    }
    return Promise.reject(error);
  },
);

export default apiAuth;
